import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { fDate } from '../utils/format-time';
// import Iconify from 'src/components/iconify';



// ----------------------------------------------------------------------

export default function ReferralDetailsTableRow({ row, }) {
  const {  transactionId,referralUsedDate,cashbackGivenDate,cashbackGiven,_id,email } = row;

  const commonTableCellStyles = {
    whiteSpace: 'nowrap',
    fontWeight: 400,
    fontSize: '16px',
    color: '#1F1F1F',
    fontFamily: 'Roboto Flex',
    lineHeight: '20px',
  };

  return (
    <>
      <TableRow hover >
        <TableCell sx={commonTableCellStyles}>{ email}</TableCell>
        <TableCell sx={commonTableCellStyles}>{fDate(referralUsedDate)}</TableCell>


        <TableCell sx={commonTableCellStyles}>{fDate(cashbackGivenDate)}</TableCell>
        <TableCell sx={commonTableCellStyles}>{transactionId }</TableCell>
        <TableCell sx={commonTableCellStyles}>₹&nbsp;{cashbackGiven} </TableCell>

      </TableRow>
    </>
  );
}

ReferralDetailsTableRow.propTypes = {
  row: PropTypes.object,
};
